export default {
    routes: [{
        path: '/posts',
        component: () => import('../pages/posts/Index.vue'),
        name: 'posts',
        meta: {
            name: 'Posts',
            title: window.titlePrefix
        }
    }]
};